import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { Dialog } from '../components/dialog';
import { IFRAME_MESSAGE_ORIGIN_INCLUDES } from '../constants';
import { SignerError } from '../errors/signer-error';
import { parseResponse } from '../utils/request-utils';
/**
 * This class is responsible for signing transactions. It only knows about Bitski's proprietary transaction objects.
 * It is also the only class that knows about the iframe signing implementation.
 */

export var BitskiTransactionSigner = /*#__PURE__*/function () {
  function BitskiTransactionSigner(webBaseUrl, apiBaseUrl, defaultHeaders, callbackURL) {
    _classCallCheck(this, BitskiTransactionSigner);

    this.webBaseUrl = webBaseUrl;
    this.apiBaseUrl = apiBaseUrl;
    this.defaultHeaders = defaultHeaders;
    this.callbackURL = callbackURL; // Watch for new messages on the window.

    window.addEventListener('message', this.receiveMessage.bind(this), false);
  }

  _createClass(BitskiTransactionSigner, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(transaction, accessToken) {
        var _this = this;

        var persisted;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.callbackURL) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return this.submitTransaction(transaction, accessToken);

              case 3:
                persisted = _context.sent;
                return _context.abrupt("return", this.redirectToCallbackURL(persisted.transaction));

              case 5:
                this.submitTransaction(transaction, accessToken).catch(function (error) {
                  return _this.handleCallback({
                    error: error
                  });
                }); // Show the modal (await response)

                return _context.abrupt("return", this.showAuthorizationModal(transaction));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
    /**
     * Event listener for callbacks from the iframe
     * @param event MessageEvent received from the browser
     */

  }, {
    key: "receiveMessage",
    value: function receiveMessage(event) {
      // Ignore messages from the current window, and from frames that aren't on Bitski.com
      if (event.source === window || !event.origin.includes(IFRAME_MESSAGE_ORIGIN_INCLUDES)) {
        return;
      }

      var data = event.data; // Ignore message events that don't actually have data

      if (data === undefined || data === null) {
        return;
      }

      this.handleCallback(data);
    }
  }, {
    key: "handleCallback",
    value: function handleCallback(callback) {
      // Ignore messages when we don't have a current request in flight
      if (this.currentRequest === undefined) {
        return;
      }

      var _this$currentRequest = _slicedToArray(this.currentRequest, 2),
          fulfill = _this$currentRequest[0],
          reject = _this$currentRequest[1]; // Dismiss current dialog


      if (this.currentRequestDialog) {
        this.currentRequestDialog.dismiss();
      } // Call the callback to complete the request


      if (callback.error) {
        reject(callback.error);
      } else {
        fulfill(callback.result);
      } // Clear state


      this.currentRequest = undefined;
      this.currentRequestDialog = undefined;
    }
    /**
     * Responsible for submitting the Transaction object to the API
     * @param transaction The Transaction object to submit
     * @param accessToken The current user's access token
     */

  }, {
    key: "submitTransaction",
    value: function () {
      var _submitTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(transaction, accessToken) {
        var requestBody, headers, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                requestBody = {
                  transaction: transaction
                };
                headers = Object.assign({}, this.defaultHeaders, {
                  'Authorization': "Bearer ".concat(accessToken),
                  'Content-Type': 'application/json'
                });
                _context2.next = 4;
                return fetch("".concat(this.apiBaseUrl, "/transactions"), {
                  method: 'POST',
                  body: JSON.stringify(requestBody),
                  headers: headers
                });

              case 4:
                response = _context2.sent;
                return _context2.abrupt("return", parseResponse(response));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submitTransaction(_x3, _x4) {
        return _submitTransaction.apply(this, arguments);
      }

      return submitTransaction;
    }()
    /**
     * Displays the authorization form in a modal window
     * @param transaction The transaction that has been submitted
     */

  }, {
    key: "showAuthorizationModal",
    value: function showAuthorizationModal(transaction) {
      var _this2 = this;

      return new Promise(function (fulfill, reject) {
        var url = "".concat(_this2.webBaseUrl, "/transactions/").concat(transaction.id);
        var iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.top = '0';
        iframe.style.left = '0';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.frameBorder = '0';
        iframe.src = url; // Dismiss any existing dialogs to prevent UI glitches.

        if (_this2.currentRequestDialog) {
          _this2.currentRequestDialog.close();
        }

        _this2.currentRequest = [fulfill, reject];
        _this2.currentRequestDialog = new Dialog(iframe, true);

        _this2.currentRequestDialog.onClose = function () {
          // Capture reject callback
          reject(SignerError.UserCancelled());
        };
      });
    }
  }, {
    key: "redirectToCallbackURL",
    value: function redirectToCallbackURL(transaction) {
      var url = "".concat(this.webBaseUrl, "/transactions/").concat(transaction.id, "?redirectURI=").concat(this.callbackURL);
      window.location.href = url;
      return Promise.resolve('');
    }
  }]);

  return BitskiTransactionSigner;
}();